import MPC from './MPC.js';

export default MPC;